module.exports = __webpack_public_path__ + "img/kwai.653e6e45.svg";